import { sendGetRequest } from '@/services/api.service'
import { API_GEOJSON } from '@/config/api.config'

export const getGeoJson = geoJson => {
  return sendGetRequest(`${API_GEOJSON.DEFAULT_API_URL}${geoJson}`)
    .then(gj => {
      const idGeojson = geoJson.substring(geoJson.indexOf('/') + 1)
      gj.features[0].properties.id = idGeojson
      return Promise.resolve(gj)
    })
    .catch(() => {
      return false
    })
}
